"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _IconButton = require("./IconButton.types");
var _Badge = require("../Badge/Badge.types");
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
var _logService = require("../tools/service/log/logService");
var _Badge2 = _interopRequireDefault(require("../Badge"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable @typescript-eslint/ban-ts-comment */
var styles = {
  "iconButton": "_3ix-Yq",
  "small": "ttwgCk",
  "medium": "t-OJVR",
  "large": "br7sg0",
  "default": "sUx1GL",
  "fixed": "cVELfb",
  "destructive": "v4o4it",
  "inverse": "Z5wiyc",
  "highlight": "GwkdD-"
};
var renderBadgeNotification = function renderBadgeNotification(notificationCount, size) {
  return /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    count: notificationCount,
    size: size === _IconButton.Size.SMALL ? _Badge.Size.SMALL : _Badge.Size.MEDIUM
  });
};
var IconButton = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    size = _ref.size,
    Icon = _ref.icon,
    notificationCount = _ref.notificationCount,
    showNotification = _ref.showNotification,
    tooltipWidth = _ref.tooltipWidth,
    showTooltip = _ref.showTooltip,
    disabled = _ref.disabled,
    children = _ref.children,
    onClick = _ref.onClick,
    ariaLabel = _ref['aria-label'],
    type = _ref.type,
    role = _ref.role,
    dataTestid = _ref['data-testid'],
    className = _ref.className,
    tabIndex = _ref.tabIndex;
  if (variant === _IconButton.Variant.FAVORITE) {
    (0, _logService.logSpecificErrorMessage)('ICONBUTTON', 'Favorite variant is deprecated in favor of `FavoriteIconButton`: https://cozy-web-storybook.quintoandar.com.br/?path=/docs/components-favoriteiconbutton-1-code--page');
  }

  // TODO: Remove this check in the future when we remove the 'default' sizing
  var finalSize = size === 'default' ? _IconButton.Size.MEDIUM : size;
  // TODO: Remove this check in the future when we remove the 'favorite' variant
  var finalVariant = variant === _IconButton.Variant.FAVORITE ? _IconButton.Variant.DEFAULT : variant;
  var builtClassnames = (0, _clsx["default"])('Cozy-IconButton', styles.iconButton, styles[finalSize], styles[finalVariant]);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    label: children || ariaLabel,
    showTooltip: showTooltip,
    tooltipWidth: tooltipWidth,
    disabled: disabled,
    className: className
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    onClick: onClick,
    "aria-label": ariaLabel || children
    // eslint-disable-next-line react/button-has-type
    ,

    type: type,
    "data-testid": dataTestid // TODO: Remove these props in the future: added it to keep support to old API id test selection
    ,

    ref: ref,
    role: role
    // @ts-ignore: We're still used to pass this a string, avoid breaking changes
    ,

    tabIndex: tabIndex,
    className: builtClassnames
  }, showNotification && renderBadgeNotification(notificationCount, size), /*#__PURE__*/_react["default"].createElement(Icon, {
    size: size === _IconButton.Size.SMALL ? _IconButton.Size.SMALL : _IconButton.Size.MEDIUM,
    title: "IconButton Icon"
  })));
});
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: _propTypes["default"].oneOf(Object.values(_IconButton.Variant)),
  children: _propTypes["default"].string,
  'aria-label': _propTypes["default"].string,
  icon: _propTypes["default"].elementType.isRequired,
  notificationCount: _propTypes["default"].number,
  showNotification: _propTypes["default"].bool,
  showTooltip: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(Object.values(_IconButton.Size)),
  tooltipWidth: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['submit', 'reset', 'button']),
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  role: _propTypes["default"].string,
  'data-testid': _propTypes["default"].string,
  // TODO: Remove these props in the future: added it to keep support to old API id test selection
  className: _propTypes["default"].string,
  tabIndex: _propTypes["default"].number
} : {};
IconButton.defaultProps = {
  showNotification: false,
  showTooltip: false,
  size: _IconButton.Size.MEDIUM,
  variant: _IconButton.Variant.DEFAULT,
  type: 'button',
  tabIndex: 0
};
var _default = exports["default"] = IconButton;